export const clickVisible = ({ row, val }) => {
  const { code } = val;
  if (code === 'fillin') {
    return ['2'].includes(row.cashStatus);
  }
  if (code === 'push_to_Bus') {
    return ['1', '4'].includes(String(row.cashStatus));
  }
  return true;
};

export const pushToBusinessPlatform = (row, request, confirm, onSuccess) => confirm(
  '确认将打款结果回传到业务平台吗？',
).then(
  () => request
    .get('/tax/v1/terminalCash/api/rePush', { seqNo: row.taxSeqNo })
    .then((res) => {
      if (res.success) {
        onSuccess(res);
      }
      return res;
    }),
  () => undefined,
);
